import { List } from "../Components/index.js";

export default [
    {
        path: "/vehicle/in-out-list",
        component: List,
        name: "vehicle-in-out",
        meta: {
            requiresAuth: true,
        },
    },
];
